const Iframe = ({ src, width, widthUnit, height, heightUnit, frameborder, scrolling, className, fullscreen }) => {
  return (
    <iframe
      className={className}
      title={src}
      width={`${width}${widthUnit || ''}`}
      height={`${height}${heightUnit || ''}`}
      src={src}
      frameBorder={`${frameborder}`}
      scrolling={scrolling ? 'yes' : 'no'}
      allowFullScreen={!!fullscreen}
    ></iframe>
  );
};

export default Iframe;
